export default __webpack_public_path__ + "static/media/netflix.f3b7f362.png";